import React, { createContext, useState } from "react";
import { getSubCategory } from "../../../axios";

export const ShoppingContext = createContext();

const ShoppingProvider = (props) => {
  const [productsBySubCategory, setProductsBySubCategory] = useState([]);
  const [flashId, setFlashId] = useState();
  const [subCategory, setSubCategory] = useState([]);
  const [activeFlash, setActiveFlash] = useState(0);
  const [flashCartModal, setFlashCartModal] = useState(false);
  const [classes, setClasses] = useState("modal fade");
  const [styles, setStyles] = useState("none");


  const [selectTypeCategory, setSelectTypeCategory] = useState(0);

  const callNewCategories = (categoryId, products) => {
    // console.log("callNewcat called" , categoryId , products);
    setFlashId(categoryId);
    const filterProducts = products?.filter((p) => p.categoryID == categoryId);
    setProductsBySubCategory(filterProducts);
    getSubCategory(categoryId).then(({ data }) => {
      if(data.length) setSubCategory(data);
      // console.log(data);
    });
    //  برای اینه که وقتی کاربر بین دسته بندی ها سوییچ کرد برگشت خالی باشه قسمت فلش کارت تا این که یک دسته بندی انتخاب کند.
    setActiveFlash(0);
  };

  return (
    <ShoppingContext.Provider
      value={{
        productsBySubCategory,
        setProductsBySubCategory,
        flashId,
        setFlashId,
        subCategory,
        setSubCategory,
        activeFlash,
        setActiveFlash,
        flashCartModal,
        setFlashCartModal,
        classes,
        setClasses,
        styles,
        setStyles,
        selectTypeCategory,
        setSelectTypeCategory,
        callNewCategories,
      }}
    >
      {props.children}
    </ShoppingContext.Provider>
  );
};

export default ShoppingProvider;
